import type { ComponentPropsWithoutRef } from "react";

import { cx } from "@/lib/tailwind-utils";

export const AnnouncementBar = ({
  children,
  className,
  ...props
}: ComponentPropsWithoutRef<"section">) => (
  <section
    className={cx(
      "flex h-10 w-full shrink-0 items-center border-b border-primary/20 bg-primary text-primary-foreground shadow-sm sm:h-9",
      className,
    )}
    {...props}
  >
    <div className="mx-auto flex h-full w-full max-w-7xl items-center gap-2 px-2 sm:px-4">
      {children}
    </div>
  </section>
);

export const announcementBarTextClassName =
  "min-w-0 flex-1 truncate text-center text-caption-emphasis text-primary-foreground sm:text-body-emphasis";
